/*
  Alma Cacao: first-order popup, v2 (Berthier 2026-10-09)
  "Try your luck": match 3 cards (every flip shows the prize, the third flip
  wins), then email, then "check your inbox" + a Shop button.
  The code SUBSCRIBE40 is NEVER shown on screen (it only works on a subscription
  and the popup does not say so): the BOS sends it by email
  (app.alma-cacao.com/api/popup/prize -> hello@alma-cacao.com), where there is
  room to explain. The Shop button here and in the email opens the cacao page
  with Subscribe & Save preselected and the discount cookie set.

  Self-contained: no dependencies, inline styles, nothing shared with
  bos-subscribe.js so a parse error here can never take the buy box down.

  Shows only on home, collections and products (allow list, 2026-10-17), after
  6 s, at 35% scroll, or on desktop exit intent. Never on blog posts, guides,
  city hub pages or any other /pages/ URL (those are the pages Google sends
  people to, so no full-screen popup there), and never on cart, checkout,
  account, the two landing A/B pages, or inside the theme editor. Dismissed:
  quiet 7 days. Claimed: never again. ?bosfo=1 forces it on any page (testing),
  ?bosfo=0 suppresses it.
  Email goes to the Klaviyo Newsletter list (XEMf37) via the public client API.

  Email link fix (2026-10-17): Shopify's /discount/ redirect drops the query string
  of the redirect target (selling_plan, bosfo=claimed, utm). The discount cookie
  survives it, so when discount_code=SUBSCRIBE40 is set: product pages preselect
  Subscribe & Save monthly once per session, and the game never shows again.

  Up to 40% (2026-10-19): the first-box discount depends on the size (1/2 lb 40%,
  1 lb 35%, 2 lb 15%, 3 lb 10%; bos-subscribe.js adds the matching codes to the
  cart), so every "40%" on screen now reads "up to 40%". Copy only.
*/
(function () {
  'use strict';
  if (window.__bosFirstOrder) return;
  window.__bosFirstOrder = true;

  var CODE = 'SUBSCRIBE40';
  var KLAVIYO_COMPANY = 'UyGwBX';
  var KLAVIYO_LIST = 'XEMf37';
  var PDP = '/products/alma-cacao';
  var PLAN_MONTHLY = '7611056358';
  var CLAIM_URL = '/discount/' + CODE + '?redirect=' + encodeURIComponent(PDP + '?selling_plan=' + PLAN_MONTHLY + '&bosfo=claimed');
  var PRIZE_API = 'https://app.alma-cacao.com/api/popup/prize';
  var KEY = 'bosFirstOrder';
  var QUIET_DAYS = 7;
  var FLIPS_TO_WIN = 3;

  // Theme asset URLs, derived from this script's own URL (no Liquid in a .js asset).
  var self = document.currentScript && document.currentScript.src ? document.currentScript.src : '';
  var assetBase = self ? self.replace(/bos-first-order\.js.*$/, '') : '';
  var ver = (self.match(/[?&]v=(\d+)/) || [])[1];           // the script's own asset version busts the image cache too
  var HERO_D = assetBase + 'bos-first-order-hero.jpg' + (ver ? '?v=' + ver : '');
  var HERO_M = assetBase + 'bos-first-order-hero-m.jpg' + (ver ? '?v=' + ver : '');
  var CDN = 'https://cdn.shopify.com/s/files/1/0702/7238/5254/files/';
  var GIFTS = [
    { src: CDN + '1_ae21d4dc-ff17-4096-ae5f-d8735505f2d4.png?v=1737099403&width=160', alt: 'Alma cacao cups' },
    { src: CDN + '20250929_1231_DramaticBohoElegance_remix_01k6b4xynmfk19v39m025h7mcs.png?v=1759164126&width=160', alt: 'Rose petals jar' },
    { src: CDN + 'cacao-hand-frothing-cacao-in-ceremonial-cup-portrait-01.png?v=1783968380&width=160', alt: 'Electric frother' }
  ];

  var path = location.pathname;
  var qs = location.search;
  var hasCode = new RegExp('(?:^|;\\s*)discount_code=' + CODE + '(?:;|$)', 'i').test(document.cookie || '');
  function firstTimeThisSession() {
    try {
      if (sessionStorage.getItem('bosfoCodePlan')) return false;
      sessionStorage.setItem('bosfoCodePlan', '1');
    } catch (e) {}
    return true;
  }

  /* ---------------------------------------------------------------- state */
  function readState() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function writeState(patch) {
    try {
      var s = readState();
      for (var k in patch) s[k] = patch[k];
      localStorage.setItem(KEY, JSON.stringify(s));
    } catch (e) { /* storage blocked: popup simply shows again next visit */ }
  }

  /* ---------------------------------------------------------- PDP preselect */
  // The buy widget rewrites the PDP URL to ?variant= on load, which can drop
  // ?selling_plan=, so the Shop click also leaves a short-lived flag in
  // localStorage; either source preselects Subscribe & Save and the cadence.
  function preselectSubscription() {
    if (!/\/products\//.test(path)) return;
    var want = (qs.match(/[?&]selling_plan=(\d+)/) || [])[1];
    var st0 = readState();
    if (!want && st0.wantPlan && Date.now() - (st0.wantAt || 0) < 15 * 60e3) want = String(st0.wantPlan);
    if (!want && hasCode && firstTimeThisSession()) want = PLAN_MONTHLY;   // arrived through the email link
    if (!want) return;
    writeState({ wantPlan: null, wantAt: null });
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var sub = document.querySelector('[data-bos-optsub] input[type="radio"]');
      if (sub) {
        clearInterval(t);
        if (!sub.checked) sub.click();
        var sel = document.querySelector('[data-bos-plan]');
        if (sel) {
          for (var i = 0; i < sel.options.length; i++) {
            if (sel.options[i].value === want) { sel.selectedIndex = i; sel.dispatchEvent(new Event('change', { bubbles: true })); break; }
          }
        }
        try { document.querySelector('[data-bos-optsub]').scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
      } else if (tries > 60) clearInterval(t);
    }, 250);
  }
  preselectSubscription();

  /* ------------------------------------------------------------- eligibility */
  var force = /[?&]bosfo=1/.test(qs);
  if (/[?&]bosfo=0/.test(qs)) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (!force) {
    var allowed = path === '/' || /^\/(collections|products)(\/|$)/.test(path);
    if (!allowed) return;
    if (/^\/(cart|checkout|checkouts|account|apps|tools|password)/.test(path)) return;
    if (/^\/pages\/(dear-coffee|someone-calmer)/.test(path)) return;
    if (/[?&]bosfo=claimed/.test(qs)) return;
    var st = readState();
    if (st.claimed) return;
    if (hasCode) { writeState({ claimed: 1, claimedAt: Date.now() }); return; }
    if (st.dismissedAt && Date.now() - st.dismissedAt < QUIET_DAYS * 864e5) return;
  }

  /* ------------------------------------------------------------------ styles */
  var css = [
    '.bosfo-wrap{position:fixed;inset:0;z-index:2147483000;background:#0F0B07 url(' + HERO_M + ') center 30%/cover no-repeat;opacity:0;transition:opacity .4s ease;font-family:Jost,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#F3EBDD}',
    '.bosfo-wrap:before{content:"";position:absolute;inset:0;background:linear-gradient(180deg,rgba(15,11,7,.05) 0%,rgba(15,11,7,.35) 40%,rgba(15,11,7,.88) 72%,#0F0B07 100%)}',
    '.bosfo-wrap.is-in{opacity:1}',
    '.bosfo-x{position:absolute;top:14px;right:14px;z-index:3;width:42px;height:42px;border-radius:50%;border:0;background:rgba(243,235,221,.92);color:#1A130C;font-size:22px;line-height:42px;text-align:center;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.25)}',
    '.bosfo-x:hover{background:#fff}',
    '.bosfo{position:absolute;left:14px;right:14px;bottom:14px;z-index:2;padding:26px 20px 22px;border-radius:22px;background:linear-gradient(180deg,#1A130C,#120D08);border:1px solid rgba(201,168,106,.42);box-shadow:0 24px 70px rgba(0,0,0,.6);text-align:center;transform:translateY(24px);transition:transform .5s cubic-bezier(.2,.7,.3,1)}',
    '.bosfo-wrap.is-in .bosfo{transform:none}',
    '.bosfo *{box-sizing:border-box}',
    '.bosfo-brand{display:block;margin:0 auto 12px;font-family:Lora,Georgia,serif;font-weight:600;font-size:15px;letter-spacing:.3em;color:#C9A86A}',
    '.bosfo-h{font-family:Lora,Georgia,serif;font-weight:500;font-size:30px;line-height:1.1;margin:0 0 8px;color:#F3EBDD}',
    '.bosfo-p{font-size:15px;line-height:1.55;color:#C9BBA3;margin:0 0 18px}',
    '.bosfo-cards{display:flex;gap:10px;justify-content:center;perspective:900px;margin:0 auto 6px}',
    '.bosfo-card{position:relative;width:68px;height:96px;border:0;background:transparent;padding:0;cursor:pointer;transform-style:preserve-3d;transition:transform .55s cubic-bezier(.2,.7,.3,1),opacity .4s ease,filter .4s ease;-webkit-tap-highlight-color:transparent;border-radius:12px}',
    '.bosfo-card:hover{transform:translateY(-4px)}',
    '.bosfo-card:focus-visible{outline:2px solid #C9A86A;outline-offset:3px}',
    '.bosfo-card.is-flip{transform:rotateY(180deg)}',
    '.bosfo-card.is-dim{opacity:.3;filter:saturate(.3);pointer-events:none}',
    '.bosfo-face{position:absolute;inset:0;border-radius:12px;backface-visibility:hidden;-webkit-backface-visibility:hidden;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#F3EBDD;color:#1A130C;box-shadow:0 6px 18px rgba(0,0,0,.35)}',
    '.bosfo-back{font-family:Lora,Georgia,serif;font-weight:600;font-size:30px}',
    '.bosfo-front{transform:rotateY(180deg);background:linear-gradient(170deg,#F7F0E2,#E9DCC3)}',
    '.bosfo-front b{font-family:Lora,Georgia,serif;font-weight:600;font-size:22px;line-height:1;color:#8A6A2E}',
    '.bosfo-front i{font-style:normal;font-size:10px;letter-spacing:.14em;text-transform:uppercase;margin-top:4px;color:#1A130C}',
    '.bosfo-won{font-family:Lora,Georgia,serif;font-weight:500;font-size:22px;color:#C9BBA3;margin:0 0 2px}',
    '.bosfo-prize{font-family:Lora,Georgia,serif;font-weight:600;font-size:46px;line-height:1.05;margin:0;color:#F3EBDD}',
    '.bosfo-upto{display:block;font-family:Jost,Arial,sans-serif;font-weight:500;font-size:13px;line-height:1;letter-spacing:.22em;text-transform:uppercase;color:#C9A86A;margin:2px 0 8px}',
    '.bosfo-front i.bosfo-u{margin:0 0 3px;font-size:8.5px;letter-spacing:.12em}',
    '.bosfo-prize2{font-family:Lora,Georgia,serif;font-weight:500;font-size:26px;line-height:1.2;margin:4px 0 20px;color:#C9A86A}',
    '.bosfo-field{width:100%;background:#F3EBDD;border:0;border-radius:999px;color:#1A130C;font:inherit;font-size:16px;padding:15px 20px;outline:0;margin-bottom:10px;text-align:center}',
    '.bosfo-field::placeholder{color:#8B7F6C}',
    '.bosfo-field:focus{box-shadow:0 0 0 3px rgba(201,168,106,.55)}',
    '.bosfo-btn{display:block;width:100%;padding:15px 20px;border:0;border-radius:999px;background:#C9A86A;color:#1A130C;font:inherit;font-size:16px;font-weight:500;text-align:center;text-decoration:none;cursor:pointer}',
    '.bosfo-btn:hover{background:#E0C27F}',
    '.bosfo-btn[disabled]{background:#8A7346;cursor:default}',
    '.bosfo-code{display:block;width:100%;border:1px dashed #C9A86A;border-radius:16px;background:rgba(243,235,221,.05);padding:16px 14px 12px;margin:0 0 12px;cursor:pointer;color:#F3EBDD}',
    '.bosfo-code b{display:block;font-size:28px;letter-spacing:.14em;font-weight:600}',
    '.bosfo-code span{display:block;margin-top:4px;font-size:12px;color:#A6957E}',
    '.bosfo-gifts{display:flex;align-items:center;justify-content:center;gap:10px;margin:18px 0 6px}',
    '.bosfo-gifts img{width:46px;height:46px;border-radius:50%;object-fit:cover;border:2px solid #C9A86A;background:#F3EBDD}',
    '.bosfo-fine{font-size:12px;line-height:1.5;color:#A6957E;margin:12px 0 0}',
    '.bosfo-err{color:#E08A6A;font-size:13px;margin:-2px 0 10px}',
    '.bosfo-rise{animation:bosfoRise .55s cubic-bezier(.2,.7,.3,1) both}',
    '@keyframes bosfoRise{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}',
    '@media (min-width:760px){',
    '.bosfo-wrap{background-image:url(' + HERO_D + ');background-position:center}',
    '.bosfo-wrap:before{background:linear-gradient(90deg,rgba(15,11,7,.55) 0%,rgba(15,11,7,0) 55%)}',
    '.bosfo{left:5vw;right:auto;bottom:auto;top:50%;transform:translateY(-50%) translateX(-24px);width:430px;padding:34px 30px 28px}',
    '.bosfo-wrap.is-in .bosfo{transform:translateY(-50%)}',
    '.bosfo-card{width:78px;height:110px}',
    '.bosfo-h{font-size:34px}',
    '.bosfo-prize{font-size:52px}',
    '.bosfo-x{top:22px;right:22px}',
    '}',
    '@media (max-width:359px){.bosfo-card{width:60px;height:86px}.bosfo-h{font-size:26px}.bosfo-prize{font-size:40px}}',
    '@media (prefers-reduced-motion:reduce){.bosfo,.bosfo-wrap,.bosfo-card,.bosfo-rise{transition:none!important;animation:none!important}}'
  ].join('');

  /* ------------------------------------------------------------------- build */
  var wrap, box, step = 'game', emailValue = '', flips = 0;

  function h(tag, cls, html) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (html != null) el.innerHTML = html;
    return el;
  }

  function render() {
    box.innerHTML = '';
    var inner = h('div', 'bosfo-rise');
    box.appendChild(inner);
    inner.appendChild(h('span', 'bosfo-brand', 'ALMA CACAO'));

    if (step === 'game') {
      inner.appendChild(h('h2', 'bosfo-h', 'Try your luck'));
      inner.appendChild(h('p', 'bosfo-p', 'Match 3 cards to see what you win.'));
      var row = h('div', 'bosfo-cards');
      for (var i = 0; i < 4; i++) {
        var c = h('button', 'bosfo-card');
        c.type = 'button';
        c.setAttribute('aria-label', 'Pick card ' + (i + 1));
        c.innerHTML = '<span class="bosfo-face bosfo-back">?</span>'
          + '<span class="bosfo-face bosfo-front"><i class="bosfo-u">up to</i><b>40%</b><i>off</i></span>';
        c.addEventListener('click', onFlip);
        row.appendChild(c);
      }
      inner.appendChild(row);
    }

    if (step === 'win') {
      inner.appendChild(h('p', 'bosfo-won', 'You won'));
      inner.appendChild(h('p', 'bosfo-prize', '<span class="bosfo-upto">Up to</span>40% off'));
      inner.appendChild(h('p', 'bosfo-prize2', '+ unique gifts'));
      var form = h('form');
      form.setAttribute('novalidate', '');
      var inp = h('input', 'bosfo-field');
      inp.type = 'email'; inp.name = 'email'; inp.placeholder = 'Your email address'; inp.autocomplete = 'email';
      inp.setAttribute('inputmode', 'email'); inp.setAttribute('autocapitalize', 'none');
      inp.value = emailValue;
      var err = h('p', 'bosfo-err', ''); err.style.display = 'none';
      var btn = h('button', 'bosfo-btn', 'Continue'); btn.type = 'submit';
      form.appendChild(inp); form.appendChild(err); form.appendChild(btn);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = (inp.value || '').trim().toLowerCase();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { err.textContent = 'That email does not look right.'; err.style.display = ''; inp.focus(); return; }
        emailValue = v; btn.disabled = true; btn.textContent = 'One moment';
        subscribe(v);
        sendPrize(v);
        track('popup_subscribe40_email');
        setTimeout(function () { step = 'inbox'; render(); }, 450);
      });
      inner.appendChild(form);
      inner.appendChild(h('p', 'bosfo-fine', 'By continuing you agree to receive emails from Alma Cacao. Leave anytime.'));
      setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (e) {} }, 500);
    }

    if (step === 'inbox') {
      inner.appendChild(h('p', 'bosfo-won', 'Check your inbox'));
      inner.appendChild(h('p', 'bosfo-h', 'Your prize is on its way.'));
      inner.appendChild(h('p', 'bosfo-p', 'We just sent your prize (up to 40% off) to <b>' + escapeHtml(emailValue) + '</b>. The button below applies it for you too.'));
      var go = h('a', 'bosfo-btn', 'Shop with up to 40% off');
      go.href = CLAIM_URL;
      go.addEventListener('click', function () { writeState({ claimed: 1, claimedAt: Date.now(), wantPlan: PLAN_MONTHLY, wantAt: Date.now() }); track('popup_subscribe40_claim'); });
      inner.appendChild(go);
      var gifts = h('div', 'bosfo-gifts');
      for (var g = 0; g < GIFTS.length; g++) {
        var im = document.createElement('img');
        im.src = GIFTS[g].src; im.alt = GIFTS[g].alt; im.loading = 'lazy';
        gifts.appendChild(im);
      }
      inner.appendChild(gifts);
      inner.appendChild(h('p', 'bosfo-fine', 'Your gifts arrive along the way. Not in your inbox? Check promotions or spam. One per customer.'));
      writeState({ claimed: 1, claimedAt: Date.now(), email: emailValue });
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function sendPrize(email) {
    try {
      fetch(PRIZE_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, page: path }),
        keepalive: true
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (j && j.ok === false) track('popup_subscribe40_email_failed');
      }).catch(function () {});
    } catch (e) { /* the Shop button still applies the code */ }
  }

  function onFlip(e) {
    var me = e.currentTarget;
    if (me.classList.contains('is-flip')) return;
    me.classList.add('is-flip');
    flips++;
    track(flips === 1 ? 'popup_subscribe40_pick' : null);
    if (flips >= FLIPS_TO_WIN) {
      var all = box.querySelectorAll('.bosfo-card');
      for (var i = 0; i < all.length; i++) { all[i].disabled = true; if (!all[i].classList.contains('is-flip')) all[i].classList.add('is-dim'); }
      setTimeout(function () { step = 'win'; render(); }, 1100);
    }
  }

  function subscribe(email) {
    try {
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Popup: SUBSCRIBE40',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { popup_offer: CODE, popup_claimed_at: new Date().toISOString(), popup_page: path },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
        body: JSON.stringify(body),
        keepalive: true
      }).catch(function () {});
      if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['identify', { $email: email }]);
    } catch (e) { /* never block the reveal */ }
  }

  function track(name) {
    if (!name) return;
    try {
      if (window.gtag) window.gtag('event', name, { code: CODE });
      else if (window.dataLayer) window.dataLayer.push({ event: name, code: CODE });
    } catch (e) {}
  }

  function dismiss() {
    if (step !== 'inbox') writeState({ dismissedAt: Date.now() });
    track('popup_subscribe40_' + (step === 'inbox' ? 'close' : 'dismiss'));
    wrap.classList.remove('is-in');
    setTimeout(function () { if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 420);
    document.removeEventListener('keydown', onKey);
    document.documentElement.style.overflow = '';
  }
  function onKey(e) { if (e.key === 'Escape') dismiss(); }

  var shown = false;
  function show() {
    if (shown) return; shown = true;
    if (!document.getElementById('bosfo-font')) {
      var l = document.createElement('link'); l.id = 'bosfo-font'; l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Lora:wght@500;600&family=Jost:wght@400;500&display=swap';
      document.head.appendChild(l);
    }
    var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);
    wrap = h('div', 'bosfo-wrap');
    wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-label', 'Try your luck: a gift for your first order');
    var x = h('button', 'bosfo-x', '&times;');
    x.type = 'button'; x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', dismiss);
    wrap.appendChild(x);
    box = h('div', 'bosfo');
    wrap.appendChild(box);
    document.body.appendChild(wrap);
    render();
    document.addEventListener('keydown', onKey);
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { wrap.classList.add('is-in'); }); });
    track('popup_subscribe40_view');
  }

  /* ---------------------------------------------------------------- triggers */
  function arm() {
    if (force) { setTimeout(show, 500); return; }
    setTimeout(show, 6000);
    var onScroll = function () {
      var d = document.documentElement;
      var max = Math.max(1, d.scrollHeight - window.innerHeight);
      if (window.scrollY / max > 0.35) { show(); window.removeEventListener('scroll', onScroll); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) show(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();
